import React from 'react';
import './Careers.css';
import Typewriter from './Typewriter';
import NeuralNetworkBackground from './NeuralNetworkBackground'; // Import background

const Careers = React.forwardRef(({ inView }, ref) => {

  const handleInteractionStart = (e) => {
    const button = e.target;
    button.textContent = 'Coming Soon...';
    button.classList.add('btn-pressed');
  };

  const handleInteractionEnd = (e, originalText) => {
    const button = e.target;
    button.textContent = originalText;
    button.classList.remove('btn-pressed');
  };

  return (
    <section id="careers" ref={ref} className="careers-section"> {/* Add ref */}
      <div className="content-wrapper" style={{ position: 'relative', zIndex: 1 }}> {/* Wrap content */}
        <div className="container">
          <h2 className="careers-title"><Typewriter id="careers-title" speed={100} replay={inView}><span className="highlight-text">AI</span> CAREERS</Typewriter></h2> {/* Pass replay */}
          <p className="careers-description">Join our team and help us build great AI powered Apps & Games</p>
          <div className="job-listings">
            <div className="job-item">
              <h3>AI Architect</h3>
              <p>Design and implement scalable AI-powered applications for diverse consumer and business needs.</p>
              <a href="#" 
                 onMouseDown={handleInteractionStart} 
                 onMouseUp={(e) => handleInteractionEnd(e, 'Apply Now')} 
                 onTouchStart={handleInteractionStart} 
                 onTouchEnd={(e) => handleInteractionEnd(e, 'Apply Now')} 
                 className="apply-btn">Apply Now</a>
            </div>
            <div className="job-item">
              <h3>Game Developer</h3>
              <p>Innovate and develop AI systems for immersive and dynamic gameplay experiences within Dhuma Games.</p>
              <a href="#" 
                 onMouseDown={handleInteractionStart} 
                 onMouseUp={(e) => handleInteractionEnd(e, 'Apply Now')} 
                 onTouchStart={handleInteractionStart} 
                 onTouchEnd={(e) => handleInteractionEnd(e, 'Apply Now')} 
                 className="apply-btn">Apply Now</a>
            </div>
            <div className="job-item">
              <h3>ML Engineer</h3>
              <p>Build, optimize, and deploy cutting-edge machine learning models that power our AI products and services.</p>
              <a href="#" 
                 onMouseDown={handleInteractionStart} 
                 onMouseUp={(e) => handleInteractionEnd(e, 'Apply Now')} 
                 onTouchStart={handleInteractionStart} 
                 onTouchEnd={(e) => handleInteractionEnd(e, 'Apply Now')} 
                 className="apply-btn">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}); // Use React.forwardRef

export default Careers;